// extracted by mini-css-extract-plugin
export default {"container":"Keyboard_container__VCOno","body":"Keyboard_body__QJWsN","button":"Keyboard_button__PUx-6","dark":"Keyboard_dark__LCEUv"};